// Module
var code = `<table class="table no-print history" ng-table="\$ctrl.tableConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Date and time</th>
    <th>Type</th>
    <th>Due Date</th>
    <th>Due Amount</th>
    <th>Days Accrued</th>
    <th>Amount Accrued</th>
    <th>Amount Paid</th>
    <th>Total AIR Balance</th>
    <th>Total AIR Paid</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$data">
    <td>{{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}} </td>
    <td>{{item.systemTime | prettyDateTime }}</td>
    <td>{{item.type | prettyEnum}}
      <span class="label status--danger" ng-if="item.entryGroup === 'REVERT'"> Revert</span></td>
    <td>{{\$ctrl.formatWithDefault(item.dueDate | prettyDate,'-')}}</td>
    <td>{{item.dueAmount | nxCurrency:'dashOnZero'}}</td>
    <td>{{\$ctrl.formatWithDefault(item.daysAccrued,'-')}}</td>
    <td>{{\$ctrl.formatAmount(item.type,item.amountAccrued | nxCurrency:'dashOnZero')}}</td>
    <td>{{\$ctrl.formatAmount(item.type,item.amountPaid | nxCurrency:'dashOnZero')}}</td>
    <td>{{item.totalAmountAccrued | nxCurrency:'dashOnZero'}}</td>
    <td>{{item.totalAmountPaid | nxCurrency:'dashOnZero'}}</td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/loan-accrual-history/loan-accrual-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;